import moment from 'moment';

//Obtiene el si el evento es futuro, pasado o presente, en los eventos que se estan emitiendo obtiene el bookmark
export const getEventTimeIndicator = (beginTime, endTime) => {
  moment.locale('ES');
  const currentTime = Date.parse(moment().format('YYYY/MM/DD HH:mm:ss'));
  const startTime = Date.parse(beginTime);
  const finishTime = Date.parse(endTime);

  if (currentTime >= startTime && currentTime < finishTime) {
    const bookmarkProgress =
      ((currentTime - startTime) / (finishTime - startTime)) * 100;

    return {
      inTime: 'presentEvent',
      bookmark: {
        last: {
          progress: Math.floor(bookmarkProgress),
        },
      },
    };
  } else if (currentTime > finishTime) {
    return {
      inTime: 'pastEvent',
      dateToEvent: `${moment(endTime).format('DD ')}${moment(endTime)
        .format('MMM')[0]
        .toUpperCase()}${moment(endTime)
        .format('MMM')
        .slice(1)}`,
    };
  } else if (currentTime < startTime) {
    return {
      inTime: 'futureEvent',
      dateToEvent: `${moment(endTime).format('DD ')}${moment(endTime)
        .format('MMM')[0]
        .toUpperCase()}${moment(endTime)
        .format('MMM')
        .slice(1)}`,
    };
  }
};

//Obtiene si un evento es futuro
export const isFutureEvent = startTime => {
  const currentTime = Date.parse(moment().format('YYYY/MM/DD HH:mm:ss'));
  return currentTime < Date.parse(startTime) ? true : false;
};
